export const FILTER_BUTTON = 'filter-button';
export const TRANSACTIONS_COUNT = 'transactions-count';
export const TRANSACTIONS_AMOUNT = 'transactions-amount';
export const TRANSACTION_HISTORY_REFRESH_BUTTON = 'transaction-refresh-button';
